import React, { useEffect, useState } from 'react';
import { Header, Table, Message, Button, Toast, Modal, Input, Field } from 'react-frontier';
import { EventPayout } from '../SiteClasses';
import { addCommas, bindClick, bindFormChange } from '../SiteUtil';
import { Checkbox, Dropdown, Icon } from 'semantic-ui-react';
import classNames from 'classnames';
import API from '../API';
import moment from 'moment';

interface ModalProps{
   open: boolean,
	payouts: EventPayout [],
	onClose?: ()=>void,
	onComplete: (cp: number[])=>void,
}

interface CompleteForm{
	completed: boolean;
	stp: boolean;
	payouts: number[];
	date_start: number;
	date_end: number;
}

var DownloadPayoutModal = (props: ModalProps)=>{
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var [dateModalPrompts, setDateModalPrompts] = useState<string[]>(null);
	var [form, setForm] = useState<CompleteForm>({ 
		completed: false, 
		stp: false, 
		payouts: [],
		date_start: null,
		date_end: null
	});
	var [downloadModal, setDownloadModal] = useState(false);
	var [dateModal, setDateModal] = useState(false);
	var [loading, setLoading] = useState<boolean>(false);
	var [pendingPayouts, setPendingPayouts] = useState<EventPayout[]>(null);

	useEffect(()=>{
		if(!props.open) return;
		get();
	}, [props.open, props.payouts]);

	var get = ()=>{
		setPendingPayouts(null);
		
		var dateStart = form.date_start ? moment.unix(form.date_start).startOf('day').unix() : null;
		var dateEnd = form.date_end ? moment.unix(form.date_end).endOf('day').unix() : null;
		
		API.getPayoutsList(500, 0, true, null, dateStart, dateEnd).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			setPendingPayouts(res.data);
			if(res.data && res.data.length === 1){
				setForm(f => ({ ...f, payouts: [res.data[0].payout_id] }));
			}
		}).catch(err=>{
			setModalPrompts(['Hubo un error cargando las liquidaciones pendientes. (DPM-1)']);
			setPendingPayouts([]);
		});
	};

	var complete = async (confirmation: boolean = false)=>{
		if(!form.stp && !form.completed) return setModalPrompts(['Necesitas marcar una opción para continuar.']);
		
		if(form.payouts.length === 0 || !pendingPayouts || pendingPayouts.length === 0) return setModalPrompts(['No hay pagos pendientes en las liquidaciones seleccionadas.'])
		
		if(form.stp && !confirmation){
			await downloadSTP();
			setDownloadModal(true);
			return;
		}
		setLoading(true);

		API.completePayout(form.payouts).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Liquidaciones completadas!');

			if(props.onComplete){
				props.onComplete(form.payouts);
			}
		}).catch(err=>{
			setModalPrompts(['Hubo un error al completar las liquidaciones. (PEE-1)']);
		}).finally(()=>{
			props.onClose && props.onClose();
			setLoading(false);
			setDownloadModal(false);
		});
	};

	var downloadSTP = async()=>{
		API.downloadPayoutsZip(form.payouts).then(res=>{
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado descargando el archivo de liquidaciones (LCL-1)']);
		});
	};

	var onFormChange = bindFormChange(form, setForm);

	var onDateFilter = ()=>{
		if(!form.date_start || !form.date_end) return setDateModalPrompts(['Debes seleccionar ambas fechas para filtrar']);
		if(form.date_end <= form.date_start) return setDateModalPrompts(['La fecha de fin debe ser mayor que la fecha de inicio']);
		get();
		setDateModal(false);
	};

	var onResetFilters = ()=>{
		setForm(f => ({ ...f, date_start: null, date_end: null }));
		setPendingPayouts(null);
		var payoutIds = props.payouts.map(p => p.payout_id);
		
		API.getPayoutsList(100, 0, true, payoutIds, null, null).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			setPendingPayouts(res.data);
			if(res.data && res.data.length === 1){
				setForm(f => ({ ...f, payouts: [res.data[0].payout_id] }));
			}
		}).catch(err=>{
			setModalPrompts(['Hubo un error cargando las liquidaciones pendientes. (DPM-1)']);
			setPendingPayouts([]);
		});
	};

	var checkboxSection = (
		<div style={{ padding: 10 }}>
			<Checkbox
				toggle
				checked={form.completed}
				label={pendingPayouts && pendingPayouts.length === 1 ? 'Esta liquidación ya se depositó' : 'Marcar como depositadas'}
				onChange={onFormChange('completed', true)}
				disabled={form.stp}
				style={{ marginTop: 15, display: 'block' }}
			/>
			<Checkbox
				toggle
				checked={form.stp}
				label={'Descargar archivo STP'}
				onChange={onFormChange('stp', true)}
				disabled={form.completed}
				style={{ marginTop: 15, display: 'block' }}
			/>
		</div>
	);

	return <div>
		<Modal open={props.open} size='small' onClose={props.onClose}>
			<Modal.Header>
				<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
					Completar liquidación
					<Dropdown
						text='Filtrar'
						icon='filter'
						labeled
						button
						style={{ color: 'black', fontSize: 14 }}
						className='icon tiny'
					>
						<Dropdown.Menu style={{ right: 0, left: 'auto' }}>
							<Dropdown.Item icon='calendar' text='Filtrar por fecha' onClick={bindClick(setDateModal, true)} />
							<Dropdown.Item icon='close' text='Borrar filtros' onClick={() => onResetFilters()} />
						</Dropdown.Menu>
					</Dropdown>
				</div>
			</Modal.Header>
			{pendingPayouts === null ? (
				<Modal.Content>
					<Header loading text='Cargando liquidaciones pendientes...' />
				</Modal.Content>
			) : pendingPayouts.length === 0 ? (
				<Modal.Content>
					<Header text='Sin pagos pendientes' subtext='No hay pagos pendientes en las liquidaciones seleccionadas.' />
					<Message type='warning' centered>
						<div style={{ fontSize: 14 }}>
							Todas las liquidaciones seleccionadas ya están completadas o no tienen pagos pendientes.
						</div>
					</Message>
					<Message type='error' list={modalPrompts} />
				</Modal.Content>
			) : pendingPayouts.length === 1 ? (
				<Modal.Content>
					<Header text='¿Completar liquidación?' subtext={'Marcará la liquidación como completada'} />
					<Table
						details
						title='Información'
						data={[
							['ID', pendingPayouts[0].payout_id],
						['Evento', pendingPayouts[0].event_name || <Icon name='minus' />],
							['Pagos pendientes', pendingPayouts[0].worker_count - pendingPayouts[0].paid_count],
							['Cantidad pendiente', '$' + addCommas(pendingPayouts[0].pending_amount || 0)],
							['Cantidad total', '$' + addCommas(pendingPayouts[0].total_amount || 0)]
						]}
					/>
					{checkboxSection}
					{pendingPayouts[0].paid_count > 0 && (
						<Message type='info' centered>
							<div style={{ fontSize: 14 }}>
								Esta liquidación tiene <b>{pendingPayouts[0].paid_count}</b> pago(s) ya completado(s). 
								Solo se procesarán los <b>{pendingPayouts[0].worker_count - pendingPayouts[0].paid_count}</b> pago(s) pendiente(s).
							</div>
						</Message>
					)}
					<Message type='error' list={modalPrompts} />
				</Modal.Content>
			) : (
				<Modal.Content style={{ maxHeight: 700, overflowY: 'auto', overflowX: 'hidden' }}>
					<div style={{ textAlign: 'center' }}>
						<Button text='Seleccionar todos' color='black' onClick={() => {
							setForm(f => ({ ...f, payouts: form.payouts.length === pendingPayouts.length ? [] : pendingPayouts.map(p => p.payout_id) }));
						}}/>
					</div>
					<Table
						selectable
						collapsingIndexes={[0, 1, 3, 4]}
						fitted
						style={{ marginTop: 15 }}
						centeredIndexes={[3, 4]}
						onClick={(v: number[]) => {
							var arr = [...form.payouts];
							var ix = arr.indexOf(v[1]);
							if(ix === -1) arr.push(v[1]);
							else arr.splice(ix, 1);
							setForm(f => ({ ...f, payouts: arr }));
						}}
						headers={[
							<div style={{ textAlign: 'center' }}>
								<i className="checkmark icon" style={{ marginRight: 0 }}></i>
							</div>,
							'ID',
							'EVENTO',
							'PENDIENTES',
							'CANTIDAD PENDIENTE'
						]}
						data={pendingPayouts.map(a=>{
							var selected = form.payouts.indexOf(a.payout_id) !== -1;
							var pendingCount = a.worker_count - a.paid_count;
							return[
								<i className={classNames('large icon circle', {
									check: selected,
									outline: !selected
								})}></i>,
								a.payout_id,
							a.event_name || <Icon name='minus' />,
								pendingCount,
								'$' + addCommas(a.pending_amount || 0)
							];
						})}
					/>
					{checkboxSection}
					<Message type='error' list={modalPrompts} />
				</Modal.Content>
			)}
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={props.onClose} />
				<Button text='Continuar' color='black' onClick={() => complete()} disabled={!form.payouts || form.payouts.length === 0 || pendingPayouts === null} />
			</Modal.Actions>
		</Modal>
		<Modal open={downloadModal} size="mini">
			<Modal.Header>Descarga STP</Modal.Header>
			<Modal.Content>
				<Header text='Se ha hecho la descarga de el archivo para subir a STP.' />
				<Message type='warning' centered>
					<div style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 10 }}>Confirmar descargar</div>
					<div>En cuanto se descargue el archivo y se verifique que no se tengan errores, se necesitará <b>confirmar la descarga</b> para marcar las liquidaciones como liquidadas y evitar cualquier tipo de doble depósito.</div>
					<Button style={{ marginTop: 15 }} text='Confirmar descarga' color='black' onClick={() => complete(true)} loading={loading} />
				</Message>
				<div style={{ textAlign: 'center', padding: 10 }}>
					<Button text='Reintentar descarga' basic onClick={downloadSTP} />
				</div>
				<Message list={modalPrompts} type='error' />
			</Modal.Content>
		</Modal>
		<Modal open={dateModal} size='mini' onClose={bindClick(setDateModal, false)}>
			<Modal.Header>Filtrar por fecha</Modal.Header>
			<Modal.Content>
				<Field amount={2}>
					<Input 
						label='Fecha inicio' 
						value={form.date_start} 
						onChange={onFormChange('date_start')}
						style={{ width: '100%'}}
						calendar={{ 
							date: moment().startOf('isoWeek').unix(), 
							mode: 'date', 
							format: 'DD/MM/YYYY' 
						}} 
					/>
					<Input 
						label='Fecha fin' 
						value={form.date_end}
						style={{ width: '100%'}}
						onChange={onFormChange('date_end')} 
						calendar={{ 
							date: moment().endOf('isoWeek').unix(), 
							mode: 'date', 
							format: 'DD/MM/YYYY' 
						}} 
					/>
				</Field>
				<Message list={dateModalPrompts} type='error' size='small'/>
			</Modal.Content>
			<Modal.Actions>
				<Button text='Cancelar' basic onClick={bindClick(setDateModal, false)} />
				<Button text='Guardar' color='black' onClick={onDateFilter} />
			</Modal.Actions>
		</Modal>
	</div>;
}

export default DownloadPayoutModal;